import type { InternalAxiosRequestConfig } from 'axios';
import { Cookies } from 'quasar';
import AbstractMiddleware from '@/services/middleware/AbstractMiddleware';
import type { AxiosRequestMiddleware } from '@/services/middleware/AxiosRequestMiddleware';

/* eslint-disable class-methods-use-this */
class CsrfTokenMiddleware extends AbstractMiddleware implements AxiosRequestMiddleware {
    /**
     * If the request is not safe, we can handle it.
     */
    public canHandleRequest(request: InternalAxiosRequestConfig): boolean {
        return !this.isSafeRequest(request);
    }

    /**
     * Hook into each transactional request and attach the csrf token.
     */
    public onRequest = (request: InternalAxiosRequestConfig): void => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const method = request.method!.toLowerCase();
        if (['post', 'put', 'patch', 'delete'].includes(method)) {
            const csrfToken = Cookies.get('CSRF-TOKEN');
            request.headers.set('X-CSRF-Token', csrfToken);
        }
    };

    /**
     * Determine if the request is safe.
     * Safe methods are: GET, HEAD, OPTIONS
     */
    private isSafeRequest = (request: InternalAxiosRequestConfig): boolean => {
        if (!request.method) {
            return false;
        }

        const method = (request.method).toLowerCase();
        return ['get', 'head', 'options'].includes(method);
    };
}

export { CsrfTokenMiddleware };
